// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_3DfqY6_nSpXIOgR6ZXxvoo","SearchContainer":"_1wU01mDgNopcpgHTj8sJES","SearchInput":"_3VRyPrVfmRsX6gjG9j-lfZ","DropdownList":"_2e2qa2JZh1gd10DLkbzKXw","slideUp":"bP0umjgn9Q4qcoa9I9_8J","DropdownItem":"H5lwC9tFk8l8R9P4c9kVp","DropdownEmpty":"_3qykghoiKFm06HR9fQlz6","SelectedTitle":"_194xqdTVyjastvrV6ZT3kg","SelectedList":"_1VkmZs6Y1OOlB8r7KUdQh0","SelectedItem":"_3RSrO4npZBieaAu32e_mpI","RemoveBtn":"G2XAplmtmEHzc4pZRitqf","ItemActions":"_3jsv_1xXn2La117qeC5dmQ","PermissionsBtn":"_1_9AoAjOjO6_xeVT42a-iu","PermissionsBtnLocked":"_2Ce24TGcy6ZVZO0En4bYqW"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/ProjectSearchList/styles.module.css
// module id = 547
// module chunks = 0